"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSFER_SOUND = exports.OUTGOING_SOUND = exports.INCOMING_SOUND = exports.HOLD_SOUND = void 0;
var _cdn = require("./cdn");
var HOLD_SOUND = exports.HOLD_SOUND = "".concat(_cdn.CDN_LEVEL_TRAVEL_CRM_SOUNDS, "/hold.mp3");
var INCOMING_SOUND = exports.INCOMING_SOUND = "".concat(_cdn.CDN_LEVEL_TRAVEL_CRM_SOUNDS, "/incoming.mp3");
var OUTGOING_SOUND = exports.OUTGOING_SOUND = "".concat(_cdn.CDN_LEVEL_TRAVEL_CRM_SOUNDS, "/outgoing.mp3");
var TRANSFER_SOUND = exports.TRANSFER_SOUND = "".concat(_cdn.CDN_LEVEL_TRAVEL_CRM_SOUNDS, "/transfer.mp3");